import { useState, useEffect, useContext } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// MindPlus examples
import Sidenav from "examples/Sidenav";

// MindPlus themes
import theme from "assets/theme";

// MindPlus routes
import routes from "routes";

// MindPlus contexts
import { useMaterialUIController } from "context";

// Images
import brandWhite from "assets/images/mindplusicon.png";
import brandDark from "assets/images/mindplusicon.png";

import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import { DataContext } from "context/dataContext";
import { AuthProvider } from "utils/AuthProvider";
import PrivateRoutes from "utils/PrivateRoutes";
import SnackbarAlert from "components/SnackbarAlert";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { layout, sidenavColor, transparentSidenav, whiteSidenav, darkMode } = controller;
  const { dataState, closeSnackbarAlert } = useContext(DataContext);
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    // <ThemeProvider theme={darkMode ? themeDark : theme}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarAlert
        color={dataState.snackbar_alert.color}
        title={dataState.snackbar_alert.title}
        open={dataState.snackbar_alert.errorSB}
        close={closeSnackbarAlert}
      />
      <AuthProvider>
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="MindPlus Healthcare"
              routes={routes}
            />
          </>
        )}
        {layout === "vr"}
        <Routes>
          <Route element={<PrivateRoutes />}>{getRoutes(routes)}</Route>
          <Route path="*" element={<SignIn />} />
          <Route path="/authentication/sign-in" element={<SignIn />} />
          <Route path="/authentication/sign-up" element={<SignUp />} />
          <Route path="/" element={<SignIn />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
